// The Leitner Revenue System - Core Framework
export const SystemSection = () => (
  <section id="system" className="py-12 sm:py-16 lg:py-20 bg-[#1C1C1C]">
    <div className="max-w-6xl mx-auto px-6 lg:px-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-semibold text-white tracking-tight mb-3">
          The Leitner Revenue System
        </h2>
        <p className="text-zinc-300">How pipeline actually gets built and converted.</p>
      </div>

      {/* Framework Flow */}
      <div className="relative">
        {/* Connection Line - Desktop */}
        <div className="hidden lg:block absolute top-1/2 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-[#D4AF37]/20 via-[#D4AF37] to-[#D4AF37]/20 -translate-y-1/2 z-0" />
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 relative z-10">
          {[
            { step: "01", title: "Targeting", desc: "Know exactly who to pursue" },
            { step: "02", title: "Messaging", desc: "Say what actually resonates" },
            { step: "03", title: "Execution", desc: "Run the motion that converts" },
            { step: "04", title: "Conversion", desc: "Turn meetings into revenue" }
          ].map((item) => (
            <div key={item.step} className="text-center">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#0A0A0A] border-2 border-[#D4AF37] flex items-center justify-center mb-4">
                <span className="text-[#D4AF37] font-mono font-medium">{item.step}</span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">{item.title}</h3>
              <p className="text-sm text-zinc-300">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default SystemSection;
